import Model, { DefaultType, MemberType } from '../../../../utils/Model';

export class TourIdentifier extends Model<TourIdentifier> {
  orgId: string;
  date: string;
  number: string;
  contractorKey?: string;

  constructor(source: unknown = null, shallow: boolean = false) {
    super();
    this.hydrateFrom(source, shallow, this.getDefaults(), this.getMembers());
  }

  get identifier(): string {
    return [this.orgId, this.date, this.number].join(':');
  }

  getDefaults(): DefaultType<TourIdentifier> {
    return undefined;
  }

  getMembers(): MemberType<TourIdentifier> {
    return undefined;
  }
}
